export const EC_REPRESENTATIVE_DATA = {
  FLOW: 'set-ec-representative-data',
  NAME: 'set-name-user-chatbot',
  EMAIL: 'set-email-user-chatbot',
  CPF: 'set-cpf-user-chatbot',
  PHONE: 'set-telephone-number-user-chatbot',
  BIRTH: 'set-telephone-birth-date-input-chatbot'
};

export const CNPJ_TYPES = {
  CNPJ_FLOW: 'flow-cnpj',
  CNPJ: 'cnpj',
  LN: 'informations-cnpj-legal-name',
  FN: 'informations-cnpj-fantasy-name',
  CNAE: 'informations-cnpj-cnae'
};

export const PARTNERS_TYPES = {
  PARTNERS_FLOW: 'partners-cnpj',
  IS_OWNER: 'question-are-you-the-owner',
  HAS_PARTNERS: 'partners-complete-question',
  PARTNERS_NAME: 'partner-name',
  PARTNERS_BIRTH: 'partner-birth-date-input',
  PARTNERS_PHONE: 'partner-phone-input',
  PARTNERS_EMAIL: 'partner-email-input',
  PARTNERS_CPF: 'partner-cpf-input'
};

export const P_LIST_TYPES = {
  P_OWNER: 'without-bureau-owner-partner',
  P_OWN_HAS_PART: 'without-bureau-owner-partner-has-partners',
  P_EMPTY: 'without-bureau-partners-list',
  P_NORMAL: 'with-bureau-partners-list'
};

export const ADDRESS = {
  ICON: 'message-receive-address-icon',
  SHOW: 'show-address-question'
};

export const BANK_TYPES = {
  BANK_FLOW: 'flow-bank',
  BANK_NAME: 'set-name-bank',
  BANK_BRANCH: 'set-bank-branch-with-digit-bank',
  BANK_ACC: 'set-account-bank',
  BANK_ACC_TYPE: 'set-account-bank-type',
  BANK_TYPE_ERROR: 'account-bank-type-error'
};

export const TERMS = {
  TERMS_FLOW: 'flow-terms',
  TERMS_CONDITIONS_ERROR: 'erro-get-conditions'
};

export const PSR_TYPES = {
  PSR_ERROR: 'psr-get-error',
  PSR_PAYMENT: 'select-psr-type',
  PSR_ECOMMERCE: 'select-psr-ecommerce',
  PSR_PHYSICAL: 'select-psr-physical',
  PSR_CONFIRM: 'psr-code-confirm',
  PSR_ONFIRM_ECOMMERCE: 'psr-code-confirm-ecommerce'
};
